const ACTIVE_WEB_VERSION_PANEL = 'v7.3.0';
export default ACTIVE_WEB_VERSION_PANEL;
